const UNSAFE_SCHEME_PATTERN = /^(javascript|data|vbscript|blob):/i;

/**
 * Returns a safe URL for use in href attributes, or null if the value is unsafe.
 * Allows http/https absolute URLs and same-origin relative paths.
 */
export function getSafeHttpUrl(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    const trimmed = url.trim();
    if (!trimmed || UNSAFE_SCHEME_PATTERN.test(trimmed)) {
        return null;
    }

    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
        return trimmed;
    }

    try {
        const parsed = new URL(trimmed, window.location.origin);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return null;
        }
        return parsed.href;
    } catch {
        return null;
    }
}
